import React from 'react';
import { Avatar } from '@mui/material';
import { colors } from '../../styles/fontStyles';
import { useThemeContext } from '../../contexts/BaseThemeContextProvider';

type AvatarInitialsProps = {
  fullName: string;
  size?: number;
};

const AvatarInitials = ({ fullName, size = 40 }: AvatarInitialsProps) => {
  const { theme } = useThemeContext();
  const getInitials = (name: string) => {
    const names = name.split(' ');
    if (names.length === 1) return names[0].substring(0, 2).toUpperCase();
    return (names[0][0] + names[1][0]).toUpperCase();
  };

  const initials = getInitials(fullName);

  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        bgcolor: theme.custom.pages.auth.home.desktopMenu.avatar.backgroundColor,
        border: `2px solid ${theme.custom.pages.auth.home.desktopMenu.avatar.borderColor}`,
        color: theme.custom.pages.auth.home.desktopMenu.avatar.color,
        fontSize: `${size / 2}px`,
        fontWeight: 'bold',
      }}
    >
      {initials}
    </Avatar>
  );
};

export default AvatarInitials;
